import { useState, useEffect } from "react";
import { Table, message } from "antd";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { loading, notLoading } from "../../../features/loading/loadingSlice";
import { selectAccessAuthorization } from "../../../features/login/loginSlice";
import { fetchWithResponse } from "../../../utils/EasyFetch";
import { errorNameToMessage } from "../../../utils/ErrorMessages";
import { SubscriptionRow } from "../../../types/subscriptions";
import { formatDate } from "../../../utils/FormattingUtils";

const SubscriptionsLayout = () => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [subscriptions, setSubscriptions] = useState<SubscriptionRow[]>([]);
  const accessToken = useAppSelector(selectAccessAuthorization);

  useEffect(() => {
    dispatch(loading());

    fetchWithResponse(
      "GET",
      "/subscriptions",
      undefined,
      "Bearer " + accessToken
    )
      .then((data) => {
        const formattedData = Object.entries(data as Record<string, any>).map(
          ([key, value]: any) => ({
            key,
            name: key,
            status: value.status,
            version: value.version,
            time: value.time,
          })
        );
        setSubscriptions(formattedData);
        dispatch(notLoading());
      })
      .catch((err: any) => {
        dispatch(notLoading());
        messageApi.error(errorNameToMessage(err.name));
      });
  }, [dispatch, accessToken, messageApi]);

  const columns = [
    {
      title: "Subscription Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
    },
    {
      title: "Last Updated",
      dataIndex: "time",
      key: "time",
      render: (text: string) => formatDate(text),
    },
  ];

  return (
    <div>
      {contextHolder}
      <Table
        dataSource={subscriptions}
        columns={columns}
        pagination={false}
        bordered={true}
        style={{ margin: "1%" }}
      />
    </div>
  );
};

export default SubscriptionsLayout;
